// Number and duration formats from docs/design/mockups/_build/shell-core.js (VL.fmt).
export const fmt = {
  int: (n) => Math.round(n).toLocaleString('en-US'),
  pct: (n, d) => `${Number(n).toFixed(d == null ? 1 : d)}%`,
  mmss: (seconds) => {
    const s = Math.round(seconds);
    const m = Math.floor(s / 60);
    const r = s % 60;
    return `${m}:${r < 10 ? '0' : ''}${r}`;
  },
  hms: (seconds) => {
    const s = Math.round(seconds);
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const r = s % 60;
    return `${h ? `${h}:${m < 10 ? '0' : ''}` : ''}${m}:${r < 10 ? '0' : ''}${r}`;
  },
  dur: (seconds) => {
    const s = Math.round(seconds);
    if (s < 60) return `${s}s`;
    const m = Math.floor(s / 60);
    const r = s % 60;
    return `${m}m ${r < 10 ? '0' : ''}${r}s`;
  },
  k: (n) => (n >= 1000 ? `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k` : String(Math.round(n))),
};

export const initials = (name) =>
  String(name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();

const AVATAR_COLORS = ['#0b79c4', '#0f8a65', '#7a4bc2', '#b2560f', '#b23a6b', '#2f7d32', '#3d54b8', '#a8432f'];

export const avatarColor = (name) => {
  let h = 0;
  const s = String(name || '');
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
};

export const seriesColor = (slot) => `var(--series-${slot})`;
